export const environment = {
  production: true,
  env: 'dev',
  // user_service_url: 'http://' + "192.168.1.74:8182" + '/api/main',

  user_service_url: 'https://' + "pgi.udiseplus.gov.in" + '/BackEnd-master/api/main',
  user_report_url: 'https://' + "pgi.udiseplus.gov.in" + '/BackEnd-master/api/report',
  user_service_pgi_url:'https://' + "pgi.udiseplus.gov.in" + '/ME-RAD-PGI/api/main',
  user_anlytical_url: 'https://' + "pgi.udiseplus.gov.in" + '/BackEnd-master/api/analytical',
  location_service_url: 'https://' + "pgi.udiseplus.gov.in" + '/BackEnd-master/np-location-service',
  pgi_service_url: 'https://' +"pgi.udiseplus.gov.in" + '/BackEnd-master/pgi-service',  
  pgi_services_url:'https://' + "pgi.udiseplus.gov.in" + '/ME-RAD-PGI/api/pgi',
  pgi_message_url:'https://' + "pgi.udiseplus.gov.in" + '/ME-RAD-PGI/api/message',
  school_dataEntry_url:'https://' + "pgi.udiseplus.gov.in" + '/BackEnd-master/api/school',
  pgi_docUpload_url:'https://pgi.udiseplus.gov.in/BackEnd-master/api/school/downloadDocument?',
  auth_service:'https://' + "pgi.udiseplus.gov.in"+'/UserService/api/userCradential', 

  //  user_service_url: 'http://' + "10.25. 26.251:8182" + '/api/main',
  //  user_service_pgi_url:'http://' + "10.25.26.251:8190" + '/api/main',
  //  user_report_url: 'http://' + "10.25.26.251:8182" + '/api/report',
  //  user_anlytical_url: 'http://' + "10.25.26.251:8182" + '/api/analytical',
  //  location_service_url: 'http://' + "10.25.26.251:8182" + '/np-location-service',
  //  pgi_service_url: 'http://' +"10.25.26.251:8182" + '/pgi-service',  
  //  pgi_services_url:'http://' + "10.25.26.251:8190" + '/api/pgi',
  //  pgi_message_url:'http://' + "10.25.26.251:8190"  + '/api/message',
  //  school_dataEntry_url:'http://' + "10.25.26.251:8182" + '/api/school',
  //  pgi_docUpload_url:'http://110.25.26.251:8182/api/school/downloadDocument?',
  //  auth_service:'http://' + "10.25.26.251:8090/meuser"+'/api/userCradential',



  //  user_service_url: 'https://' + "demopgi.udiseplus.gov.in" + '/BackEnd-master/api/main',
  //  user_service_pgi_url:'https://' + "demopgi.udiseplus.gov.in" + '/BackEnd-master/api/main',
  //  user_report_url: 'https://' + "demopgi.udiseplus.gov.in" + '/BackEnd-master/api/report',
  //  user_anlytical_url: 'https://' + "demopgi.udiseplus.gov.in" + '/BackEnd-master/api/analytical',
  //  location_service_url: 'https://' + "demopgi.udiseplus.gov.in" + '/BackEnd-master/np-location-service',
  //  pgi_service_url: 'https://' +"demopgi.udiseplus.gov.in" + '/BackEnd-master/pgi-service',  
  //  pgi_services_url:'https://' + "demopgi.udiseplus.gov.in" + '/BackEnd-master/api/pgi',
  //  pgi_message_url:'https://' + "demopgi.udiseplus.gov.in"  + '/BackEnd-master/api/message',
  //  school_dataEntry_url:'https://' + "demopgi.udiseplus.gov.in" + '/BackEnd-master/api/school',
  //  pgi_docUpload_url:'https://demopgi.udiseplus.gov.in/BackEnd-master/api/school/downloadDocument?',


  // user_service_url: 'http://' + "demo.sdmis.gov.in" + '/BackEnd-master/api/main',
  // user_report_url: 'http://' + "demo.sdmis.gov.in" + '/BackEnd-master/api/report',
  // user_service_pgi_url:'http://' + "demo.sdmis.gov.in" + '/ME-RAD-PGI/api/main',
  // user_anlytical_url: 'http://' + "demo.sdmis.gov.in" + '/BackEnd-master/api/analytical',
  // location_service_url: 'http://' + "demo.sdmis.gov.in" + '/BackEnd-master/np-location-service',
  // pgi_service_url: 'http://' +"demo.sdmis.gov.in" + '/BackEnd-master/pgi-service',  
  // pgi_services_url:'http://' + "demo.sdmis.gov.in" + '/ME-RAD-PGI/api/pgi',
  // pgi_message_url:'http://' + "demo.sdmis.gov.in" + '/ME-RAD-PGI/api/message',
  // school_dataEntry_url:'http://' + "demo.sdmis.gov.in" + '/BackEnd-master/api/school',
  // pgi_docUpload_url:'http://demo.sdmis.gov.in/BackEnd-master/api/school/downloadDocument?',
  // auth_service:'http://' + "demo.sdmis.gov.in"+'/UserService/api/userCradential',


  


  success_code: 'NP001',
  pgi_success_code : 'APP001',
  user_service_user: 'np-usr-rest:W',
  user_service_pass: 'UsVCNuxne@123',
  loc_service_user: 'np-loc-rest:W',
  loc_service_pass: 'LoVCNuxne@123',
  pgi_service_user: 'np-appusr-rest:W',
  pgi_service_pass: 'Xy#!@#@123',
  sign_key: 'QD32VdbRuMa0iI0q9q7cH6FIHGcNWGdEZOLyK669',
  encr_pass: 'KeheUber'
};

